import { createFileRoute } from "@tanstack/react-router";
import { ConditionPageLayoutEs } from "@/components/ConditionPageLayoutEs";
import { esSuicidalIdeation } from "@/pages/es/esConditionData2";
import { buildEsConditionHead } from "@/pages/es/esConditionShared";

export const Route = createFileRoute(
  "/es/suicidal-ideation-treatment-coral-springs-fl",
)({
  head: () => buildEsConditionHead(esSuicidalIdeation),
  component: RouteComponent,
});

function RouteComponent() {
  return <ConditionPageLayoutEs cfg={esSuicidalIdeation} />;
}
